import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IEntity } from "../../../../../base/types"
import { IRadioGroupProps } from './IRadioGroupProps'
import React from 'react'
import clsx from 'clsx'
import { useFormContext } from "../../form"
import { useFormikContext } from "formik"
import { useRadioGroupValidationSchema } from './RadioGroupValidationSchema'

interface IRadioGroupFieldProps extends HTMLAttributes<HTMLInputElement>, IRadioGroupProps {
    name: string
}

export const RadioGroupField: FC<IRadioGroupFieldProps> = (props) => {
    const { id, name, className, title, required, disabled, options } = props
    const shape = useRadioGroupValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: '' }

    return <>
        <div className="d-flex gap-3">
            {options?.map(({ label, value }, i) => <React.Fragment key={i}>
                <div title={title} className="form-check">
                    <label htmlFor={`${id}-${value}`}
                        className={clsx("form-check-label fw-semibold fs-7 my-0", { "required": required })}>
                        {label}
                    </label>
                    <input
                        type="radio"
                        id={`${id}-${value}`}
                        {...fieldProps}
                        value={value}
                        className={clsx(className, "form-check-input")}
                        checked={value === fieldProps.value}
                        disabled={disabled}
                    />
                </div>
            </React.Fragment>)}
        </div>
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}
